import { gql } from '@apollo/client';
import config from 'config';

const itemIndex = config.algolia.algolia_prefix + 'items';

export const GET_ITEM = gql`
    query getItem($input: GetItemInput!) {
        getItem(input: $input) {
            data {
                id
                taffiId
                collection
                price
                currency
                available
                title
                description
                colors {
                    id
                    title
                    value
                    subject
                }
                sizes {
                    id
                    title
                    value
                    subject
                }
                categories {
                    id
                    name
                }
                tags {
                    id
                    name
                }
                labels {
                    id
                    name
                }
                brand {
                    id
                    name
                    imageUrl
                }
                url
                images
                creator
                itemCodes
                accessLevel
                user {
                    id
                    phone
                    lastName
                    email
                    firstName
                    userType
                    approved
                    userName
                    bio
                    profileImageUrl
                    featured
                }
                storeId
                storeProductId
                inStock
            }
            paging {
                size
                page
            }
        }
    }
`;
export const GET_ITEM_COMMON = gql`
    query getItem($input: GetItemInput!) {
        getItem(input: $input) {
            data {
                id
                taffiId
                collection
                price
                currency
                available
                title
                description
                colors {
                    id
                    title
                    value
                    subject
                }
                sizes {
                    id
                    title
                    value
                    subject
                }
                categories {
                    id
                    name
                }
                tags {
                    id
                    name
                }
                labels {
                    id
                    name
                }
                brand {
                    id
                    name
                    imageUrl
                }
                url
                images
                creator
                # itemCodes
                accessLevel
                user {
                    id
                    phone
                    lastName
                    email
                    firstName
                    userType
                    approved
                    userName
                    bio
                    profileImageUrl
                    featured
                }
                storeId
                storeProductId
                store {
                    id
                    name
                    platform
                    shopifyDomain
                    taffiId
                    url
                }
                inStock
            }
            paging {
                size
                page
            }
        }
    }
`;

export const GET_ITEM_BY_ID = gql`
    query LocationsQuery($query: String!, $filters: String!) {
        algolia_get_item_by_id
            @algolia(
                __typename: "ALGOLIA_GET_ITEM_BY_ID"
                index: ${itemIndex}
                filters: $filters
                hitsPerPage: 1
                query: $query
                page: 0
            ) {
            hits
            nbHits
            facets
            page
            nbPages
        }
    }
`;

export const GET_ITEMS_BY_ID = gql`
    query LocationsQuery($query: String!, $filters: String!) {
        algolia_get_item_by_id
        @algolia(
            __typename: "ALGOLIA_GET_ITEM_BY_ID"
            index: ${itemIndex}
            filters: $filters
            hitsPerPage: 20
            query: $query
            page: 0
        ) {
            hits
            nbHits
            facets
            page
            nbPages
        }
    }
`;
